export const logs = {
  createdBlock: 'Utworzono blok',
  deletedBlock: 'Usunięto blok',
  blockChanged: 'Zmieniono parametr bloku',
  movedBlock: 'Przesunięto blok',
  blockDrag: 'Przeciąganie bloku',
  variableCreated: 'Utworzono zmienną',
  variableDeleted: 'Usunięto zmienną',
  variableRenamed: 'Zmieniono nazwę zmiennej',
  commentCreated: 'Dodano komentarz',
  commentDeleted: 'Usunięto komentarz',
  commentChanged: 'Zmieniono treść komentarza',
  commentMoved: 'Przesunięto komentarz',
  uiAction: 'Akcja interfejsu',
  elementSelected: 'Zaznaczono element',
  elementClicked: 'Kliknięto w element',
  viewportChanged: 'Zmiana widoku obszaru roboczego',
  trashcanChanged: 'Zmiana stanu kosza',
  toolboxItemSelected: 'Zmiana kategorii w przyborniku',
  themeChanged: 'Zmieniono motyw graficzny',
  finishedLoading: 'Zakończono wczytywanie projektu',
  other: 'Inna operacja',
}
